// extracted by mini-css-extract-plugin
export var price = "Price-module--price--2Q6le";
export var finalPrice = "Price-module--final-price--1cRJk";
export var beginPrice = "Price-module--begin-price--3Z4J0";